import React, {useState, useEffect} from "react";
import DonutChart from "./DonutChart";
import {Table} from "reactstrap";
import {useVsiAppContext} from "../stores/VsiApp";
import {genericColors} from "../utils/chartUtils";
import themeStyles from "../utils/themeStyles";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

const Td = ({children, name, className}) => {
    const cn = `${className}`;

    return name === "Total" ? (
        <th className={cn}>{children}</th>
    ) : (
        <td className={cn}>{children}</td>
    )
}

const generateTotal = data => {
    if (data.filter(f => f.name === 'Total').length > 0) return [...data].sort((a, b) => a.name === 'Total' ? 1 : b.name === 'Total' ? -1 : -1);
    // data.pop(data.filter(f => f.name.trim() === 'Total'));
    let total = data.reduce((accumulator, currentValue) => accumulator + currentValue.y, 0);

    return [...data, {name: 'Total', y: total.toFixed(2)}];
}

const checkIsInt = data => data.every(({ y }) => y % 1 === 0);

function PieGrid({data, title, gridConfig = [], colors, isGridOpen = false, alignTitle = 'center'}) {
    const {theme} = useVsiAppContext();
    const [isOpen, setIsOpen] = useState(isGridOpen);
    const [isInt, setIsInt] = useState(checkIsInt(data));
    const [allData, setAllData] = useState([]);

    useEffect(() => {
        setIsInt(checkIsInt(data));
        setAllData(generateTotal(data).filter(datum => (datum.name !== 'Total')));
    }, [data]);
    
    const returnColorsWithIndex = index => {
        const setColors = (colors || genericColors);
        return setColors.length < (index + 1) ? returnColorsWithIndex(index - (setColors.length)) : setColors[index];
    }

    const formatTdValue = value => {
        if (!isInt) {
            return parseFloat(value).toLocaleString?.("en-US",  { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
        return parseInt(value);
    }

    return <div>
        <section>
            <DonutChart data={allData}
                        alignTitle={alignTitle}
                        title={title}
                        colors={colors}
                        seriesName={gridConfig?.[1] || 'Value'}/>
        </section>
        <section className={"p-2"} style={{backgroundColor: themeStyles[theme].cardBgColor,}}>
            <Table hover responsive dark={theme === "dark"} style={{zIndex: 1000, overflowWrap: 'anywhere'}}>
                <thead style={{cursor: "pointer"}}>
                <tr onClick={() => setIsOpen(!isOpen)}>
                    {gridConfig.map((config, index) => (
                        <th className={`p-2 text-${index === 0 ? 'start' : 'end'}`}
                            key={`pie-grid-${config.split(' ').join('')}-header-${index}`}
                            style={{overflowWrap: 'normal'}}>
                            {index === 0 &&
                                <i className={`me-2 ${!isOpen ? "fas fa-caret-down" : "fas fa-caret-up"}`}/>}
                            {config}
                        </th>
                    ))}
                </tr>
                </thead>
                <tbody style={{
                    display: !isOpen ? 'none' : 'contents',
                    zIndex: 1000
                }}>
                {allData.map((datum, index) => {
                    return <tr key={`pie-grid-t-row-${index}`}>
                        <Td name={datum.name}>
                            {datum.name !== 'Total' &&
                                <i className={"fas fa-circle pe-1"} style={{color: returnColorsWithIndex(index),}}/>}
                            {datum.name}
                        </Td>
                        <Td name={datum.name} className={"text-end"}>
                            {formatTdValue(datum.y).toLocaleString()}
                        </Td>
                    </tr>
                })}
                </tbody>
            </Table>
        </section>
    </div>
}

export default withErrorBoundary(PieGrid, GeneralErrorBoundary);
